import { CertificateStatus } from "@tfg/types/constants/certificates.constants"
import {
  AGECResponses,
  RecycledMaterialPercentageCause,
} from "@tfg/types/endpoints/agec"

// TODO remove after plugging agecData
export const agecData: AGECResponses.GenericAgecData = {
  productSheetGroupId: "e0e17022-f85e-45c8-9a2f-c8a1555cfb7d",
  organizationName: "Company Name",
  productAttributes: {
    name: "White tshirt",
    brand: "Fashion Brand",
    color: "sand",
    collection: "Summer 2025",
    brandReference: "1234567890",
    purchaseOrderReference: "1234567890",
  },
  type: "other-apparel",
  brand: null,
  lastUpdate: "07/03/2025",
  operations: [
    {
      id: "product-APPAREL_MANUFACTURING-11424",
      type: "product",
      itemId: 64962,
      country: { country: "CN" },
      childrenRef: ["component-FABRIC_WEAVING_OR_KNITTING-22059"],
      activityName: "APPAREL_MANUFACTURING",
      certificates: [
        {
          name: "Social Audit Proof (ICS  BSCI or SMETA only accepted)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Social Audit Proof (ICS  BSCI or SMETA only accepted)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
        {
          name: "Transactionnal Recycled content proof (GRS or RCS)",
          standardId: 1,
          status: CertificateStatus.PROCESSED,
        },
      ],
    },
    {
      id: "component-FABRIC_WEAVING_OR_KNITTING-22059",
      type: "component",
      itemId: 64963,
      country: { country: "CN" },
      childrenRef: ["component-FABRIC_DYEING_PRINTING-22059"],
      activityName: "FABRIC_WEAVING_OR_KNITTING",
      certificates: [
        /* same pattern as above */
      ],
    },
    {
      id: "component-FABRIC_DYEING_PRINTING-22059",
      type: "component",
      itemId: 64963,
      country: { country: "CN" },
      childrenRef: [
        "material-FABRIC_SPINNING-31486",
        "material-FABRIC_SPINNING-31487",
      ],
      activityName: "FABRIC_DYEING_PRINTING",
      certificates: [],
    },
    {
      id: "material-FABRIC_SPINNING-31486",
      type: "material",
      itemId: 64964,
      country: { country: "CN" },
      childrenRef: ["material-FABRIC_MATERIAL_PRODUCTION-31486"],
      activityName: "FABRIC_SPINNING",
      certificates: [],
    },
    {
      id: "material-FABRIC_MATERIAL_PRODUCTION-31486",
      type: "material",
      itemId: 64964,
      country: { country: "CN" },
      childrenRef: [],
      activityName: "FABRIC_MATERIAL_PRODUCTION",
      certificates: [],
    },
    {
      id: "material-FABRIC_SPINNING-31487",
      type: "material",
      itemId: 64965,
      country: { country: "CN" },
      childrenRef: ["material-FABRIC_MATERIAL_PRODUCTION-31487"],
      activityName: "FABRIC_SPINNING",
      certificates: [],
    },
    {
      id: "material-FABRIC_MATERIAL_PRODUCTION-31487",
      type: "material",
      itemId: 64965,
      country: { country: "CN" },
      childrenRef: [],
      activityName: "FABRIC_MATERIAL_PRODUCTION",
      certificates: [],
    },
  ],
  operationChainName: "APPAREL",
  recycledFibers: {
    percentage: 0,
    cause:
      RecycledMaterialPercentageCause.BY_INGESTED_MATERIAL_COMPOSITION_RECYCLED_PERCENTAGE,
  },
  picture: null,
  releasesMicroPlastic: true,
  agecActivityCountries: [
    { activityName: "APPAREL_MANUFACTURING", country: { country: "CN" } },
    { activityName: "FABRIC_WEAVING_OR_KNITTING", country: { country: "IN" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "FR" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "DE" } },
    { activityName: "FABRIC_DYEING_PRINTING", country: { country: "US" } },
  ],
  withPrimaryPackaging: false,
  primaryPackagingRecyclable: false,
  primaryPackagingRecycledPercentage: null,
  primaryPackagingHazardousSubstances: false,
  components: [],
  ecoScoreData: {
    ecoScoreCost: 10,
    ecoScoreCostPer100g: 10,
    percentFilled: 10,
  },
  agecActivityCountriesByComponentsAndMaterials: {},
}

export const productPageComponents = [
  {
    id: "f6d0854a-f4c4-4fa4-8d76-fa43478b5de9",
    componentType: "HEADER_WITH_PRODUCT_NAME",
    content: {},
    order: 1,
  },
  {
    id: "d0294e4d-7a36-4bb4-90bf-fd1167896f4d",
    componentType: "TEXT_PARAGRAPH",
    content: {
      EN: [
        {
          type: "title",
          textContent: [
            {
              text: "Our initiative",
              type: "title",
            },
          ],
        },
        {
          type: "paragraph_block",
          textContent: [
            {
              text: "Pimkie is committed to transparency to meet the requirements of the AGEC law. With regard to this, Pimkie Positive is our movement for more transparency and traceability!",
              type: "text",
            },
          ],
        },
      ],
      FR: [
        {
          type: "title",
          textContent: [
            {
              text: "Notre démarche",
              type: "title",
            },
          ],
        },
        {
          type: "paragraph_block",
          textContent: [
            {
              text: "Pimkie fait le choix de la transparence pour répondre aux enjeux de la loi AGEC. Au détail de cela, Pimkie Positive est notre mouvement pour plus de transparence et de traçabilité !",
              type: "text",
            },
          ],
        },
      ],
    },
    order: 3,
  },
  {
    id: "67ab8de6-336b-46fa-ba7a-e76c6f837594",
    componentType: "TEXT_PARAGRAPH",
    content: {
      EN: [
        {
          type: "title",
          textContent: [
            {
              text: "Traceability",
              type: "text",
            },
          ],
        },
        {
          type: "paragraph_block",
          textContent: [
            {
              text: "It refers to the origin of your product across its first three stages of production, from its manufacturing to the weaving and dyeing of its primary material.",
              type: "text",
            },
          ],
        },
      ],
      FR: [
        {
          type: "title",
          textContent: [
            {
              text: "Tracabilité",
              type: "text",
            },
          ],
        },
        {
          type: "paragraph_block",
          textContent: [
            {
              text: "Il s'agit de l'origine de votre produit sur ses trois premières étapes de production depuis sa confection jusqu'au tissage et à la teinture de sa matière principale.",
              type: "text",
            },
          ],
        },
      ],
    },
    order: 4,
  },
  {
    id: "19bc58be-6f37-4046-a7f7-d2b7d3d8d8a6",
    componentType: "ACTIVITY_LIST_WITH_ICONS",
    content: {},
    order: 5,
  },
  {
    id: "31848b2c-38b8-4fb8-8ebe-0b0bdb126e2d",
    componentType: "RECYCLED_MATERIALS_INFO",
    content: {},
    order: 6,
  },
  {
    id: "40386541-a68e-43b2-a00e-0c8db967eef9",
    componentType: "PACKAGING_INFO",
    content: {},
    order: 7,
  },
  {
    id: "dc4fdce7-a8ef-4c9f-9024-b55efb2dab6e",
    componentType: "TRIMAN_FOOTER_POWERED_BY",
    content: {},
    order: 8,
  },
  {
    id: "9d03e34e-2498-4311-b8c6-8e192826003f",
    componentType: "GENERIC_PASSPORT_TITLE",
    content: {},
    order: 9,
  },
]
